import script from "./ApiRouter.vue?vue&type=script&lang=js"
export * from "./ApiRouter.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__